import { AxiosPromise } from 'axios';
import request, { AxiosRequestCustomConfig } from '@/umi-request';
import { MetricSectionResponse, MetricSectionsResponse } from '@/interfaces/metrics';

export function getMetricSections(): AxiosPromise<MetricSectionsResponse> {
  return request({
    url: 'metrics/sections/',
    method: 'GET',
    skipAuth: false,
    skipErrorPage: true,
  } as AxiosRequestCustomConfig);
}

export function getMetricSection(
  slug: string,
  params: Record<string, unknown> = {},
): AxiosPromise<MetricSectionResponse> {
  return request({
    url: `metrics/sections/${encodeURIComponent(slug)}/`,
    method: 'GET',
    params,
    // Los errores se presentan dentro de la vista para permitir reintentar.
    skipAuth: false,
    skipErrorPage: true,
  } as AxiosRequestCustomConfig);
}
